import { dbFieldTypeMap } from '@databases/collab/convert/to-collab';
import { DatabaseFieldType } from '@databases/types/database';
import { type DatabaseChangeType } from '@databases/types/redux';

import { MultiValueChangeType } from '../../../../database/changesets';
import { type YJSChangeHandler } from '../../types';
import { applyDeltaValue } from '../../utils/apply-delta-value';
import { getConvertedValue } from '../../utils/get-converted-value';
import { getOrSetValue } from '../../utils/get-or-set-value';

export const setDatabaseId: YJSChangeHandler<DatabaseChangeType.SET_DATABASE_ID> = ({
  ydb,
  change,
  state
}) => {
  const destType = dbFieldTypeMap[DatabaseFieldType.ENTRY_LINK];

  const convertedValue = getConvertedValue(
    ydb,
    change.fieldId,
    ydb.defaultEntry.getValue(change.fieldId),
    destType,
    state
  );

  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];

    field.databaseId = change.contentId;

    applyDeltaValue(
      (destType) =>
        getOrSetValue(db.defaultEntry, change.fieldId, destType, convertedValue),
      {
        type: DatabaseFieldType.ENTRY_LINK,
        delta: { value: [], type: MultiValueChangeType.SET_TO }
      }
    );
  });
};
